import { useEffect, useState } from "react"
import { changeUserGlobalCommands, getUserGlobalCommands } from "../../services/userApis"
import { toast } from "react-toastify"

const COMMANDS = [{ en: "virtualserver_name" }]

const ServerCommands = ({ user }) => {
    const [userGlobalCommands, setUserGlobalCommands] = useState(null)

    useEffect(() => {
        if (user) {
            getUserGlobalCommands()
                .then(({ data }) => {
                    setUserGlobalCommands(data)
                })
                .catch((err) => {
                    console.error(err)
                })
        }
    }, [user])
    if (!userGlobalCommands) {
        return (
            <>
                <h3>درحال بارگذاری...</h3>
            </>
        )
    }
    return (
        <div dir="ltr" className="w-full h-full y-scroll">
            <div dir="rtl" className="mx-14">
                <h3 className="mb-5">تنظیمات دیفالت هنگام ساخت سرور:</h3>
                <form
                    onSubmit={(event) => {
                        event.preventDefault()
                        const form = new FormData(event.target)
                        let formGlobalCommands = {}
                        formGlobalCommands["virtualserver_name"] = form.get("virtualserver_name")
                        formGlobalCommands["virtualserver_welcomemessage"] = form.get("virtualserver_welcomemessage")
                        formGlobalCommands["virtualserver_password"] = form.get("virtualserver_password")
                        formGlobalCommands["virtualserver_hostmessage"] = form.get("virtualserver_hostmessage")
                        formGlobalCommands["virtualserver_hostmessage_mode"] = form.get(
                            "virtualserver_hostmessage_mode",
                        )
                        formGlobalCommands["virtualserver_max_upload_total_bandwidth"] = form.get(
                            "virtualserver_max_upload_total_bandwidth",
                        )
                        formGlobalCommands["virtualserver_max_download_total_bandwidth"] = form.get(
                            "virtualserver_max_download_total_bandwidth",
                        )
                        formGlobalCommands["virtualserver_antiflood_points_tick_reduce"] = form.get(
                            "virtualserver_antiflood_points_tick_reduce",
                        )
                        formGlobalCommands["virtualserver_antiflood_points_needed_command_block"] = form.get(
                            "virtualserver_antiflood_points_needed_command_block",
                        )
                        formGlobalCommands["virtualserver_antiflood_points_needed_ip_block"] = form.get(
                            "virtualserver_antiflood_points_needed_ip_block",
                        )
                        formGlobalCommands["virtualserver_hostbanner_gfx_url"] = form.get(
                            "virtualserver_hostbanner_gfx_url",
                        )
                        formGlobalCommands["virtualserver_hostbanner_url"] = form.get("virtualserver_hostbanner_url")
                        formGlobalCommands["virtualserver_hostbanner_mode"] = form.get("virtualserver_hostbanner_mode")

                        if (formGlobalCommands !== userGlobalCommands) {
                            toast
                                .promise(changeUserGlobalCommands(formGlobalCommands), {
                                    pending: "درحال تغییر دستور همگانی",
                                    success: "تغییر داده شد",
                                    error: "error",
                                })
                                .catch((err) => {
                                    console.error(err)
                                })
                        }
                    }}
                >
                    <div className="mb-3">
                        <label for="virtualserver_name" class="block mb-2 text-sm font-medium  text-gray-300">
                            اسم سرور:
                        </label>
                        <input
                            type="text"
                            name="virtualserver_name"
                            id="virtualserver_name"
                            class="styled-input"
                            placeholder="اسم سرور"
                            defaultValue={userGlobalCommands["virtualserver_name"]}
                        />
                    </div>
                    <div className="mb-3">
                        <label for="virtualserver_welcomemessage" class="block mb-2 text-sm font-medium  text-gray-300">
                            پیام خوش آمدگویی:
                        </label>
                        <input
                            type="text"
                            name="virtualserver_welcomemessage"
                            id="virtualserver_welcomemessage"
                            className="styled-input"
                            placeholder="پیام خوش آمدگویی"
                            defaultValue={userGlobalCommands["virtualserver_welcomemessage"]}
                        />
                    </div>
                    <div className="mb-3">
                        <label for="virtualserver_password" class="block mb-2 text-sm font-medium  text-gray-300">
                            پسورد:
                        </label>
                        <input
                            type="text"
                            name="virtualserver_password"
                            id="virtualserver_password"
                            className="styled-input"
                            placeholder="پسورد"
                            defaultValue={userGlobalCommands["virtualserver_password"]}
                        />
                    </div>
                    <div className="grid grid-cols-5 gap-5">
                        <div className="mb-3 col-span-4">
                            <label
                                for="virtualserver_hostmessage"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                هاست مسیج:
                            </label>
                            <input
                                type="text"
                                name="virtualserver_hostmessage"
                                id="virtualserver_hostmessage"
                                className="styled-input"
                                placeholder="هاست مسیج"
                                defaultValue={userGlobalCommands["virtualserver_hostmessage"]}
                            />
                        </div>
                        <div class="mb-3 col-span-1">
                            <label className="block mb-2 text-sm font-medium text-gray-300" for="grid-state">
                                مود:
                            </label>
                            <select class="styled-input " id="grid-state" name="virtualserver_hostmessage_mode">
                                <option value="1">LOG</option>
                                <option value="2">MODAL</option>
                                <option value="3">MODALQUIT</option>
                            </select>
                            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker"></div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label
                            for="virtualserver_max_download_total_bandwidth"
                            class="block mb-2 text-m font-medium  text-gray-300"
                        >
                            دانلود:
                        </label>
                        <input
                            type="number"
                            name="virtualserver_max_download_total_bandwidth"
                            id="virtualserver_max_download_total_bandwidth"
                            className="styled-input"
                            placeholder="Bytes/s"
                            defaultValue={userGlobalCommands["virtualserver_max_download_total_bandwidth"]}
                        />
                    </div>
                    <div className="mb-3">
                        <label
                            for="virtualserver_max_upload_total_bandwidth"
                            class="block mb-2 text-m font-medium  text-gray-300"
                        >
                            آپلود:
                        </label>
                        <input
                            type="number"
                            name="virtualserver_max_upload_total_bandwidth"
                            id="virtualserver_max_upload_total_bandwidth"
                            className="styled-input"
                            placeholder="‌Bytes/s"
                            defaultValue={userGlobalCommands["virtualserver_max_upload_total_bandwidth"]}
                        />
                    </div>
                    <h3>آنتی فلود</h3>
                    <div class="border p-3 pl-6 rounded-lg">
                        <div className="mb-3">
                            <label
                                for="virtualserver_antiflood_points_tick_reduce"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                :Reduced points per tick
                            </label>
                            <input
                                type="number"
                                name="virtualserver_antiflood_points_tick_reduce"
                                id="virtualserver_points_tick_reduce"
                                className="styled-input"
                                placeholder="Reduced points per ticks"
                                defaultValue={userGlobalCommands["virtualserver_antiflood_points_tick_reduce"]}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                for="virtualserver_antiflood_points_needed_command_block"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                :Points needed to block commands
                            </label>
                            <input
                                type="number"
                                name="virtualserver_antiflood_points_needed_command_block"
                                id="virtualserver_antiflood_points_needed_command_block"
                                className="styled-input"
                                placeholder="Points needed to block commands"
                                defaultValue={userGlobalCommands["virtualserver_antiflood_points_needed_command_block"]}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                for="virtualserver_antiflood_points_needed_ip_block"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                :Points needed to block IP
                            </label>
                            <input
                                type="number"
                                name="virtualserver_antiflood_points_needed_ip_block"
                                id="virtualserver_antiflood_points_needed_ip_block"
                                className="styled-input"
                                placeholder="Points needed to block IP"
                                defaultValue={userGlobalCommands["virtualserver_antiflood_points_needed_ip_block"]}
                            />
                        </div>
                    </div>
                    <h3>هاست بنر</h3>
                    <div class="border p-3 pl-6 rounded-lg">
                        <div className="mb-3">
                            <label
                                for="virtualserver_hostbanner_gfx_url"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                :Banner Gfx Url
                            </label>
                            <input
                                type="text"
                                name="virtualserver_hostbanner_gfx_url"
                                id="virtualserver_hostbanner_gfx_url"
                                className="styled-input"
                                placeholder="Hostbanner gfx url"
                                defaultValue={userGlobalCommands["virtualserver_hostbanner_gfx_url"]}
                            />
                        </div>
                        <div className="mb-3">
                            <label
                                for="virtualserver_hostbanner_url"
                                class="block mb-2 text-sm font-medium  text-gray-300"
                            >
                                :URL
                            </label>
                            <input
                                type="text"
                                name="virtualserver_hostbanner_url"
                                id="virtualserver_hostbanner_url"
                                className="styled-input"
                                placeholder="Hostbanner Url"
                                defaultValue={userGlobalCommands["virtualserver_hostbanner_url"]}
                            />
                        </div>
                        <div class="mb-3 col-span-1">
                            <label className="block mb-2 text-sm font-medium text-gray-300" for="grid-state">
                                :Resize
                            </label>
                            <select
                                class="styled-input "
                                id="grid-state"
                                name="virtualserver_hostbanner_mode"
                                defaultValue={userGlobalCommands["virtualserver_hostbanner_mode"]}
                            >
                                <option value="0">Do not adjust</option>
                                <option value="1">Adjust but ignore aspect ratio</option>
                                <option value="2">Adjust and keep aspect ratio</option>
                            </select>
                            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker"></div>
                        </div>
                    </div>
                    <button type="submit" class="styled-button px-4 py-2 m-2">
                        تغییر
                    </button>
                </form>
            </div>
        </div>
    )
}

export default ServerCommands
